import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./Section";

export const FAQ_ITEMS = [
  {
    q: "Apakah KalkuBisnis cocok untuk yang baru mau memulai usaha?",
    a: "Ya. KalkuBisnis dapat membantu kamu membuat gambaran biaya, HPP, harga jual, dan BEP berdasarkan data yang kamu masukkan sebelum memulai atau mengembangkan usaha.",
  },
  {
    q: "Apakah cocok untuk usaha yang sudah berjalan?",
    a: "Ya. Kamu dapat menggunakan fitur perhitungan biaya dan harga serta fitur pencatatan penjualan yang tersedia untuk membantu meninjau angka usahamu.",
  },
  {
    q: "Apakah harus bisa akuntansi?",
    a: "KalkuBisnis dirancang untuk membantu perhitungan usaha dengan cara yang praktis. Video panduan penggunaan juga disertakan agar kamu bisa mempelajari fitur-fiturnya secara bertahap.",
  },
  {
    q: "Apakah aplikasi bisa dibuka lewat HP?",
    a: "Ya. KalkuBisnis merupakan aplikasi web yang bisa diakses melalui browser di HP atau komputer dengan koneksi internet.",
  },
  {
    q: "Apakah ada biaya bulanan atau perpanjangan tahunan?",
    a: "Pembelian dilakukan satu kali tanpa biaya langganan atau perpanjangan tahunan. Akses tersedia selama layanan KalkuBisnis tetap beroperasi.",
  },
  {
    q: "Kapan saya menerima akun?",
    a: "Setelah pembayaran terverifikasi, administrator akan membuat akun dan mengirimkan informasi akses menggunakan data kontak yang tersedia pada pesanan.",
  },
  {
    q: "Apakah KalkuBisnis menjamin usaha saya akan untung?",
    a: "Tidak. KalkuBisnis membantu perhitungan dan pencatatan usaha, tetapi hasil usaha tetap bergantung pada ketepatan data, harga pasar, biaya, penjualan, dan keputusan yang kamu ambil.",
  },
];

export function Faq() {
  return (
    <section id="faq" className="scroll-mt-20 bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading title="Pertanyaan yang Sering Ditanyakan" />
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem key={item.q} value={`faq-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-question-${i + 1}`}
                  className="text-left text-sm font-semibold text-slate-900 hover:text-teal-700 sm:text-base"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-slate-600">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
